import InteriorDesignIcon from "../../assets/product-list-assets/interior-design.svg";
import type { ProductListGroup } from "../../types";

export const physicalSecurityInteriorDesign: ProductListGroup = {
  id: "physicalSecurityInteriorDesign",
  title: "productListGroup.interiorDesign.title",
  seriesLabel: "modelCompare.seriesLabel.physicalSecurityInteriorDesign",
  icon: {
    src: InteriorDesignIcon,
    width: 20,
    height: 21,
  },
};
